import { useEffect } from 'react';

/**
 * 横竖屏切换后，部分移动端 WebView 的 rem/vw 视口单位不刷新，导致帖子富文本图片仍保持
 * 旋转前的尺寸（过宽 / 被裁剪）。经真机诊断，纯 JS 重算根字号 / 重置视口 / 强制重排均
 * 无法让其正确回流。
 *
 * 兜底方案：**监听横竖屏切换，一旦发生切换就刷新页面**，让 WebView 以新方向重新完整
 * 渲染。该 hook 仅挂在移动端（H5）详情页，对所有移动端环境生效，不做 UA 限制。
 *
 * 说明：只监听方向切换（matchMedia orientation + orientationchange），不监听 resize，
 * 以免软键盘等引起的尺寸变化误触发刷新。
 */
export default function useReflowOnOrientationChange() {
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const reload = () => {
      window.location.reload();
    };

    const mql = window.matchMedia('(orientation: portrait)');

    // Safari / 旧 WebView 兼容：优先 addEventListener，回退 addListener
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', reload);
    } else if (typeof mql.addListener === 'function') {
      mql.addListener(reload);
    }
    window.addEventListener('orientationchange', reload);

    return () => {
      if (typeof mql.removeEventListener === 'function') {
        mql.removeEventListener('change', reload);
      } else if (typeof mql.removeListener === 'function') {
        mql.removeListener(reload);
      }
      window.removeEventListener('orientationchange', reload);
    };
  }, []);
}
